import React from "react";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import { useState, useEffect, useRef } from "react";

import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import Confirmation from "../App/Confirmation";
import { useGlobalState } from "../Context/GlobalStateContext";
import { SanitizeHtml, getAccessSettings } from "../Shared/Utility";
import * as XLSX from "xlsx";
function GroupList() {
  const globalState = useGlobalState();
  const [groupGridData, setGroupGridData] = useState([]);
  const [groupPFIDealerGridData, setGroupPFIDealerGridData] = useState(
    []
  ) as any;
  const [PFIDealerGridData, setPFIDealerGridData] = useState([]) as any;

  const [showAnimation, setShowAnimation] = useState(false);

  const [currentView, setCurrentView] = useState(1);
  {
    /*MM:: 1 means grid view.. 2 means add view and 3 means edit view*/
  }

  const [groupData, setGroupData] = useState({
    IBBGroupID: 0,
    Name: "",
    Description: "1",
    SelectedImporters: "",
  });

  useEffect(() => {
    IBBGroupGetCompleteGridData();
    IBBGroupPFIDealerGetCompleteGridDataCustom(0);
  }, []);

  useEffect(() => {
    if (groupData.IBBGroupID > 0) IBBGroupPFIDealerGetCompleteGridDataCustom(0);
  }, [groupData.IBBGroupID]);

  useEffect(() => {
    checkPFIDealerAlreadyInGroup(groupPFIDealerGridData);
  }, [groupPFIDealerGridData]);

  function IBBGroupGetCompleteGridData() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.recordsperpage = 100;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBGroup/IBBGroupGetCompleteGridData",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          setGroupGridData(result[1]);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBGroupSaveCustom() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbgroupid = groupData.IBBGroupID;
    object.name = SanitizeHtml(groupData.Name);
    object.description = groupData.Description;
    object.selectedimporters = groupData.SelectedImporters;
    setShowAnimation(true);
    axiosAuth
      .post(AppContext.AppBaseURL + "api/IBBGroup/IBBGroupSaveCustom", object)
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          setCurrentView(1);
          IBBGroupGetCompleteGridData();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBGroupDeleteRecord(IBBGroupID: number) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbgroupid = IBBGroupID;
    setShowAnimation(true);
    axiosAuth
      .post(AppContext.AppBaseURL + "api/IBBGroup/IBBGroupDeleteRecord", object)
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          IBBGroupGetCompleteGridData();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBGroupPFIDealerGetCompleteGridDataCustom(IBBGroupID: number) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbgroupid = IBBGroupID;
    object.recordsperpage = 100;
    object.isdeleted = false;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBGroupPFIDealer/IBBGroupPFIDealerGetCompleteGridDataCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          setGroupPFIDealerGridData(result[0]);
          setPFIDealerGridData(result[1]);
          checkPFIDealerAlreadyInGroup(result[0]);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBGroupPFIDealerSaveCustom(
    IBBGroupPFIDealerID: number,
    IBBGroupID: number,
    PFIDealerID: number,
    IsDeleted: boolean,
    ImporterCount: number
  ) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbgrouppfidealerid = IBBGroupPFIDealerID;
    object.ibbgroupid = IBBGroupID;
    object.pfidealerid = PFIDealerID;
    object.isdeleted = IsDeleted;
    object.importercount = ImporterCount;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBGroupPFIDealer/IBBGroupPFIDealerSaveCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function checkPFIDealerAlreadyInGroup(groupPFIDealerGridDataParam: any) {
    let PFIDealerGridDataLocal = PFIDealerGridData;
    for (let i = 0; i < PFIDealerGridDataLocal.length; i++) {
      let PFIDealerID = PFIDealerGridDataLocal[i].PFIDealerID;
      var filtered = groupPFIDealerGridDataParam.filter(
        (item: any) =>
          item.PFIDealerID == PFIDealerID &&
          item.IBBGroupID == groupData.IBBGroupID
      );
      if (filtered.length > 0) {
        PFIDealerGridDataLocal[i].IBBGroupPFIDealerID =
          filtered[0].IBBGroupPFIDealerID;
        PFIDealerGridDataLocal[i].IsChecked = true;
        PFIDealerGridDataLocal[i].IsDeleted = false;
      } else {
        PFIDealerGridDataLocal[i].IsChecked = false;
        PFIDealerGridDataLocal[i].IsDeleted = true;
      }
    }
    if (PFIDealerGridDataLocal.length > 0)
      setPFIDealerGridData(PFIDealerGridDataLocal);
  }

  function updateImporterListInGroup(index: number, type: number, value: any) {
    let PFIDealerGridDataLocal = PFIDealerGridData as any;
    if (type == 1) {
      PFIDealerGridDataLocal[index].IsChecked = value;
      PFIDealerGridDataLocal[index].IsDeleted = !value;
    }

    let selectedImporters = "";
    var filtered = PFIDealerGridDataLocal.filter(
      (item: any) => item.IsChecked == true
    );

    for (let i = 0; i < filtered.length; i++) {
      if (selectedImporters == "") selectedImporters = filtered[i].PFIDealerID;
      else selectedImporters += "," + filtered[i].PFIDealerID;
    }

    setGroupData((prevState: any) => ({
      ...prevState,
      SelectedImporters: selectedImporters,
    }));

    if (groupData.IBBGroupID > 0) {
      IBBGroupPFIDealerSaveCustom(
        PFIDealerGridDataLocal[index].IBBGroupPFIDealerID,
        groupData.IBBGroupID,
        PFIDealerGridDataLocal[index].PFIDealerID,
        PFIDealerGridDataLocal[index].IsDeleted,
        filtered.length
      );
    }

    setPFIDealerGridData(PFIDealerGridDataLocal);
  }

  function ConfirmationCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        IBBGroupDeleteRecord(obj.SelectedID);
      }
    }
    globalState.setConfirmationObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
    });
  }

  // Download in Excel function
  function DownloadClientsDataInExcel(id: any, name: any) {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      document.getElementById(id)
    );
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, name);

    XLSX.writeFile(wb, name + ".xlsx");
  }

  return (
    <>
      {showAnimation && <LoadingAnimation />}
      <Confirmation
        ConfirmationObject={globalState.ConfirmationObject}
        ConfirmationCallBack={ConfirmationCallBack}
      />
      {currentView == 1 && (
        <div className="page--contents">
          <div className="page--breadcrumb">
            <a>Group List</a>
          </div>
          <div className="page--data">
            <div className="flex-container">
              <span></span>
              <div className="flex-items">
              {getAccessSettings(2, 20) > 1 && (
                <a
                  className="btn-link"
                  onClick={() => {
                    setGroupData({
                      IBBGroupID: 0,
                      Name: "",
                      Description: "1",
                      SelectedImporters: "",
                    });
                    setGroupPFIDealerGridData([]);
                    checkPFIDealerAlreadyInGroup([]);
                    setCurrentView(2);
                  }}
                >
                  Add Group
                </a>
              )}

              <a
                className="btn-primary"
                title="Export"
                onClick={() =>
                  DownloadClientsDataInExcel("tblGroupListGROUP", "GROUP LIST")
                }
              >
                <img src="images/export.svg" width="18" height="18" />
              </a>
              </div>
            </div>
            <div className="section-table">
              <table
                className="part-head trend-table fixed-table"
                id="tblGroupListGROUP"
              >
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Importer #</th>
                    <th className="md-col"></th>
                  </tr>
                </thead>
                <tbody>
                  {groupGridData &&
                    groupGridData.map((item: any, index: any) => (
                      <React.Fragment key={"group" + index}>
                        {item.Description == "1" && (
                          <tr>
                            <td>{item.Name}</td>
                            <td className="text-right">{item.ImporterCount}</td>
                            <td className="md-col">
                              <div className="width-100 text-center btn-sm-grid">
                                {getAccessSettings(2, 20) > 1 && (
                                  <a
                                    className="btn-primary btn-grid"
                                    onClick={() => {
                                      setCurrentView(3);
                                      setGroupData(item);
                                    }}
                                    title="Edit"
                                  >
                                    <img
                                      src="images/edit.svg"
                                      width={15}
                                      height={15}
                                    />
                                  </a>
                                )}
                                {getAccessSettings(2, 20) > 1 && (
                                  <a
                                    className="btn-primary btn-grid"
                                    // onClick={() => {
                                    //   IBBGroupDeleteRecord(item.IBBGroupID);
                                    // }}
                                    onClick={() => {
                                      globalState.setConfirmationObject({
                                        ShowPopup: true,
                                        Heading: "Confirmation ",
                                        Message:
                                          "Are you sure you want to delete this record?",
                                        ID: 1,
                                        SelectedID: item.IBBGroupID,
                                      });
                                    }}
                                    title="Delete"
                                  >
                                    <img
                                      src="images/delete.svg"
                                      width={15}
                                      height={15}
                                    />
                                  </a>
                                )}
                              </div>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {(currentView == 2 || currentView == 3) && (
        <>
          <div className="page-contents">
            <div className="page--breadcrumb">
              {currentView == 2 && <a>Add Group</a>}
              {currentView == 3 && <a>Edit Group</a>}
            </div>
            <div className="page--data">
              <div className="program-form form-group">
                <div className="form-item">
                  <span>Name:</span>
                  <input
                    type="text"
                    value={groupData.Name}
                    onChange={(e) =>
                      setGroupData((prevState: any) => ({
                        ...prevState,
                        Name: e.target.value,
                      }))
                    }
                  ></input>
                </div>
                <div className="form-item form-top">
                  <span>Importers:</span>
                  <div className="flex-check-importers">
                    {PFIDealerGridData &&
                      PFIDealerGridData.map((item: any, index: any) => (
                        <React.Fragment key={"programPFIDealer" + index}>
                          <div className="flex-check-inner">
                            <input
                              type="checkbox"
                              className="input-check"
                              checked={item.IsChecked}
                              onChange={(e) =>
                                updateImporterListInGroup(
                                  index,
                                  1,
                                  !item.IsChecked
                                )
                              }
                            />
                            <span>
                              {item.DealerName}&nbsp;[{item.MarketName}]
                            </span>
                          </div>
                        </React.Fragment>
                      ))}
                  </div>
                </div>
                <div className="form-btns">
                  <a onClick={IBBGroupSaveCustom}>Save</a>
                  <a
                    onClick={() => {
                      setCurrentView(1);
                      IBBGroupGetCompleteGridData();
                    }}
                  >
                    Cancel
                  </a>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default GroupList;
